<template>
  <div class="styj">

    <Head v-bind:headTxt="headTxt"></Head>

    <YangBen v-bind:YangBenBox="YangBenBox"></YangBen>

    <ShiJi v-bind:shiJiBox="shiJiBox"></ShiJi>

    <RightBox v-bind:rightBox="rightBox"></RightBox>

    <div class="map_box">
      <Map v-bind:mapBut="mapBut"></Map>
    </div>

    <div class="l_box">
      <div class="bgc l_box_1">
        <div class="title">物质富裕</div>
        <div style="display: flex;">
          <div class="lbox">
            <div class="chart1"
                 id="l_chart_1">
            </div>
          </div>
          <div class="rbox">
            <div class="rbox_1">
              <span style="left: 16%;top: -15%;">宽带覆盖率</span>
              <span style="right: 14%;top: -15%;">自来水覆盖率</span>
              <div class="chart1"
                   id="l_chart_xiuxian">
              </div>
            </div>
            <div class="rbox_2">
              <div v-show="wuzhiImgList1.length > 0">
                <el-carousel height="100%"
                             indicator-position="none">
                  <el-carousel-item v-for="(item,index) in wuzhiImgList1"
                                    :key="index">
                    <el-image style="width:100%; height:100%"
                              :src="item"
                              fit="cover"></el-image>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div v-show="wuzhiImgList1.length == 0">
                <span class="noTxt"
                      style="line-height:15vh;margin-left:20%">暂无调研图片</span>
              </div>
              <div v-show="wuzhiImgList1.length > 0">
                <el-carousel height="100%"
                             indicator-position="none">
                  <el-carousel-item v-for="(item,index) in wuzhiImgList2"
                                    :key="index">
                    <el-image style="width:100%; height:100%"
                              :src="item"
                              fit="cover"></el-image>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div v-show="wuzhiImgList1.length == 0">
                <span class="noTxt"
                      style="line-height:15vh;margin-left:20%">暂无调研图片</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bgc l_box_2">
        <div class="title">精神富裕</div>
        <div class="nr_box">
          <div class="nr_box_l">
            <div class="nr_box_l1">
              <div v-show="tiyuImgList.length > 0">
                <el-carousel height="100%"
                             indicator-position="none">
                  <el-carousel-item v-for="(item,index) in tiyuImgList"
                                    :key="index">
                    <el-image style="width:100%; height:100%"
                              :src="item"
                              fit="cover"></el-image>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div v-show="tiyuImgList.length == 0">
                <span class="noTxt"
                      style="line-height:20vh;margin-left:35%;">暂无调研图片</span>
              </div>
              <span>传统体育：{{this.shfyList.region}}</span>
            </div>
            <div class="nr_box_l2">
              <div v-show="jieriImgList.length > 0">
                <el-carousel height="100%"
                             indicator-position="none">
                  <el-carousel-item v-for="(item,index) in jieriImgList"
                                    :key="index">
                    <el-image style="width:100%; height:100%"
                              :src="item"
                              fit="cover"></el-image>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div v-show="jieriImgList.length == 0">
                <span class="noTxt"
                      style="line-height:20vh;margin-left:35%;">暂无调研图片</span>
              </div>
              <span>传统文化：{{this.shfyList.region}}</span>
            </div>
          </div>
          <div class="nr_box_r">
            <div class="chart1"
                 id="l_chart_jingsheng">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import YangBen from '@/components/YangBen.vue'
import RightBox from '@/components/RightBox.vue'
import ShiJi from '@/components/ShiJi.vue'
import Map from '@/components/Map.vue'
import bus from '../utils/bus.js'


export default {
  components: {
    Head,
    YangBen,
    RightBox,
    Map,
    ShiJi
  },
  data () {
    return {
      city_id: 0,
      shfyList: {
      },
      wuzhiImgList1: [],
      wuzhiImgList2: [],
      tiyuImgList: [],
      jieriImgList: [],
      YangBenBox: {
        xian: '123',
        xiang: '12',
        cun: '1'
      },
      headTxt: '生活富裕数据仓',
      shiJiBox: {
        shiJiTitle: '生活富裕大事记',
        diDian: '湖南省',
        shiJiList: [
          '勾蓝瑶寨农村环境整治整体推进综合治理项目，自2018年6月开工建设以来，共投资60余万元，对全村进行集中整治。建设了农村饮用水项目、生活污水治理项目、生活垃圾收集系统、农村改厕改水和农村“五清五化”治理等。',
          '2022年8月，青年水库，水域面积750多亩，总库容600余万立方米，主要用于农业灌溉、城市生态补水、防洪排涝、景观用水等，提升青年水库水质，加强周边生态环境保护尤为重要。',
        ]
      },
      rightBox: {
        boxTitle: '湖南民族地区生活富裕简介',
        boxText: '湖南地形以山地丘陵为主，大陆性亚热带季风湿润气候。党的十八大以来,湖南深入践行习近平生态文明思想,牢记“守护好一江碧水”的殷殷嘱托,以前所未有的力度推进生态文明建设,全省生态环境发生了历史性、转折性、全局性变化。',
        images: [],
      },
      mapBut: '湖南交通地图>>>',

      // 物质富裕
      wuZhiChar: null,

      wuZhiFGChar: null,

      jingshengChar: null,


    }
  },
  mounted () {
    this.getDate()

    bus.$on('mapBus', (date) => {
      this.city_id = date.city_id
      this.getDate(date)
    })
  },
  methods: {
    getDate (date) {
      let newDate = "";
      if (date) {
        newDate = date.region;
      } else {
        newDate = "永州市";
      }

      console.log(this.city_id);
      var date = JSON.parse(localStorage.getItem("date"));
      date.forEach((item, index) => {
        if (item.region == newDate) {
          this.shfyList = item;
        }
      });

      this.rightBox.images = []
      const introList = this.shfyList.live_intro.split('#')
      this.rightBox.boxText = introList[0]
      for (let i = 1; i < introList.length; i++)
      {
        this.rightBox.images.push(introList[i])
      }
      console.log(this.rightBox, '数据处理后');

      // 物质富裕
      this.wuZhiEcharts()

      this.wuZhiFGEcharts()

      this.jingshengcharts()

      // 物质1图片
      var reading_imgList = []
      var bulletin_imgList = []
      var pavilion_imgList = []
      reading_imgList = this.shfyList.elist.map((item) => {
        return item.reading_img
      })
      pavilion_imgList = this.shfyList.elist.map((item) => {
        return item.pavilion_img
      })
      this.wuzhiImgList1 = reading_imgList.concat(pavilion_imgList)
      for (var i = this.wuzhiImgList1.length - 1; i >= 0; i--)
      {
        if (this.wuzhiImgList1[i] == "" || this.wuzhiImgList1[i] == null)
        {
          this.wuzhiImgList1.splice(i, 1);
        }
      }
      if (this.wuzhiImgList1.length > 0)
      {
        this.wuzhiImgList1 = this.wuzhiImgList1.join('、')
        this.wuzhiImgList1 = this.wuzhiImgList1.split('、')
      }
      console.log(this.wuzhiImgList1, '物质1图片');

      // 物质2图片
      var fitnesse_imgList = []
      var street_imgList = []
      fitnesse_imgList = this.shfyList.elist.map((item) => {
        return item.fitnesse_img
      })
      street_imgList = this.shfyList.elist.map((item) => {
        return item.street_img
      })
      this.wuzhiImgList2 = fitnesse_imgList.concat(street_imgList)
      for (var i = this.wuzhiImgList2.length - 1; i >= 0; i--)
      {
        if (this.wuzhiImgList2[i] == "" || this.wuzhiImgList2[i] == null)
        {
          this.wuzhiImgList2.splice(i, 1);
        }
      }
      if (this.wuzhiImgList2.length > 0)
      {
        this.wuzhiImgList2 = this.wuzhiImgList2.join('、')
        this.wuzhiImgList2 = this.wuzhiImgList2.split('、')
      }
      console.log(this.wuzhiImgList2, '物质2图片');

      // 传统体育
      this.tiyuImgList = this.shfyList.elist.map((item) => {
        return item.sports_img
      })
      for (var i = this.tiyuImgList.length - 1; i >= 0; i--)
      {
        if (this.tiyuImgList[i] == "" || this.tiyuImgList[i] == null)
        {
          this.tiyuImgList.splice(i, 1);
        }
      }
      if (this.tiyuImgList.length > 0)
      {
        this.tiyuImgList = this.tiyuImgList.join('、')
        this.tiyuImgList = this.tiyuImgList.split('、')
      }
      console.log(this.tiyuImgList, '传统体育图片');

      // 传统节日
      this.jieriImgList = this.shfyList.elist.map((item) => {
        return item.celebration_img
      })
      for (var i = this.jieriImgList.length - 1; i >= 0; i--)
      {
        if (this.jieriImgList[i] == "" || this.jieriImgList[i] == null)
        {
          this.jieriImgList.splice(i, 1);
        }
      }
      if (this.jieriImgList.length > 0)
      {
        this.jieriImgList = this.jieriImgList.join('、')
        this.jieriImgList = this.jieriImgList.split('、')
      }
      console.log(this.jieriImgList, '传统节日图片');

      // 处理大事记数据
      this.shiJiBox.shiJiList = this.shfyList.elist.map((item) => {
        return item.event_date + '  |  ' + item.event_influence + '  |  ' + item.event_name
      })
      console.log(this.shiJiBox.shiJiList);
      for (var i = this.shiJiBox.shiJiList.length - 1; i >= 0; i--)
      {
        if (this.shiJiBox.shiJiList[i] == "  |    |  " || this.shiJiBox.shiJiList[i] == "null  |  null  |  null" || this.shiJiBox.shiJiList[i] == "无  |  无  |  无")
        {
          this.shiJiBox.shiJiList.splice(i, 1);
        }
      }
      console.log(this.shiJiBox.shiJiList);

    },


    // 物质富裕
    wuZhiEcharts () {
      this.wuZhiChar = this.$echarts.init(document.getElementById("l_chart_1"));
      //窗口变动，echart重绘
      window.addEventListener("resize", () => {
        this.wuZhiChar.resize()
      });
      var optoin = {
        // title: {
        //   text: '损耗电量统计分析图',
        // },
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          // data: ['供电量（单位：kWh）', '售电量（单位：kWh）', '耗损电量（单位：kWh）']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            axisLabel:
            {
              show: true,
              interval: 0,//使x轴上的文字显示完全,
              color: '#000',
              fontWeight: 900
            },
            data: ['文化设施', '休闲设施']
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel:
            {
              show: true,
              interval: 0,//使x轴上的文字显示完全,
              color: '#000',
              fontWeight: 900
            },
          }
        ],
        series: [
          {
            name: '总计',
            type: 'bar',
            label: { //柱体上显示数值
              show: true,//开启显示
              position: 'top',
              formatter: '{c}',
            },
            data: [this.shfyList.e_Facility_culture + this.shfyList.e_Facility_play, this.shfyList.e_Facility_culture + this.shfyList.e_Facility_play]
          },
          {
            name: '阅览室',
            type: 'bar',
            label: { //柱体上显示数值
              show: true,//开启显示
              position: 'top',
              formatter: '{c}',
            },
            data: [this.shfyList.e_Facility_culture, this.shfyList.e_Facility_culture]
          },
          {
            name: '健身器材',
            type: 'bar',
            label: { //柱体上显示数值
              show: true,//开启显示
              position: 'top',
              formatter: '{c}',
            },
            data: [this.shfyList.e_Facility_play, this.shfyList.e_Facility_play]
          }
        ]
      }
      this.wuZhiChar.setOption(optoin)
    },

    // 物质富裕
    wuZhiFGEcharts () {
      this.wuZhiFGChar = this.$echarts.init(document.getElementById("l_chart_xiuxian"));
      //窗口变动，echart重绘
      window.addEventListener("resize", () => {
        this.wuZhiFGChar.resize()
      });
      var optoin = {
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        series: [
          /*第一个小饼*/
          {
            name: '宽带覆盖率',
            type: 'pie',
            radius: '90%',
            center: ['25%', '50%'],
            color: ['#eeeeee', '#36e4bb'],
            data: [
              { value: 100 - this.shfyList.e_Ethernet, name: '无' },
              { value: this.shfyList.e_Ethernet, name: '有' }
            ],
            itemStyle: {  //图形样式
              borderRadius: 3,
              borderColor: '#666',
            },
            label: {
              normal: {
                formatter: function (params) {
                  if (params.value > 0)
                  {
                    return params.value + '%';
                  } else
                  {
                    return '';
                  }
                },
                position: 'inner',
                rich: {
                  a: {
                    // color: '#ccc',
                    fontSize: 14,
                    lineHeight: 15,
                    align: "center"
                  },
                  b: {                        //name 文字样式
                    fontSize: 14,
                    lineHeight: 15,
                    // color: '#666',
                    align: "center"

                  },
                  c: {                   //value 文字样式
                    fontSize: 14,
                    lineHeight: 15,
                    // color: '#666',
                    align: "center"
                  }
                }
              }
            },
          },
          {
            name: '自来水覆盖率',
            type: 'pie',
            radius: '90%',
            center: ['75%', '50%'],
            color: ['#eee', '#ea97dd'],
            data: [
              { value: 100 - this.shfyList.e_Tap_water, name: '没' },
              { value: this.shfyList.e_Tap_water, name: '真有' }
            ],
            itemStyle: {  //图形样式
              borderRadius: 3,
              borderColor: '#666',
            },
            label: {
              normal: {
                formatter: function (params) {
                  if (params.value > 0)
                  {
                    return params.value + '%';
                  } else
                  {
                    return '';
                  }
                },
                position: 'inner',
                rich: {
                  a: {
                    // color: '#ccc',
                    fontSize: 14,
                    lineHeight: 15,
                    align: "center"
                  },
                  b: {                        //name 文字样式
                    fontSize: 14,
                    lineHeight: 15,
                    // color: '#666',
                    align: "center"

                  },
                  c: {                   //value 文字样式
                    fontSize: 14,
                    lineHeight: 15,
                    // color: '#666',
                    align: "center"
                  }
                }
              }
            },
          }
        ]
      }
      this.wuZhiFGChar.setOption(optoin)
    },

    // 精神富裕
    jingshengcharts () {
      this.jingshengChar = this.$echarts.init(document.getElementById("l_chart_jingsheng"));
      //窗口变动，echart重绘
      window.addEventListener("resize", () => {
        this.jingshengChar.resize()
      });
      var optoin = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        xAxis: {
          axisLabel:
          {
            show: true,
            interval: 0,//使x轴上的文字显示完全,
            color: '#000',
            fontWeight: 900
          },
          data: ['文化', '体育', '节日', '总计']
        },
        yAxis: {
          axisLabel:
          {
            show: true,
            interval: 0,//使x轴上的文字显示完全,
            fontSize: this.$fontSize.fontSize(0.1),
            color: '#000',
            fontWeight: 900
          },
        },
        grid: {
          top: '10%',
          left: '3%',
          right: '8%',
          bottom: '3%',
          containLabel: true
        },
        series: [

          {
            type: 'bar',
            label: { //柱体上显示数值
              show: true,//开启显示
              position: 'top',
              formatter: '{c}',
            },
            data: [
              {
                value: this.shfyList.e_Culture,
                itemStyle: {
                  color: '#5B8FF9'
                }
              },
              {
                value: this.shfyList.e_Sports,
                itemStyle: {
                  color: '#E8684A'
                }
              },
              {
                value: this.shfyList.e_Festival,
                itemStyle: {
                  color: '#9270CA'
                }
              },
              {
                value: this.shfyList.e_Culture + this.shfyList.e_Sports + this.shfyList.e_Festival,
                itemStyle: {
                  color: '#269A99'
                }
              },
            ]
          }
        ]
      }
      this.jingshengChar.setOption(optoin)
    },

  }
}
</script>

<style lang="less" scoped>
.map_box {
  position: absolute;
  top: 7vh;
  left: 35%;
  width: 39%;
  height: 87vh;
}

.l_box {
  position: absolute;
  top: 16vh;
  left: 0;
  width: 34%;
  height: 65vh;
  margin: 1vh;
  .l_box_1 {
    height: 34vh;
    .lbox {
      flex: 2;
      height: 34vh;
      .chart1 {
        width: 100%;
        height: 100%;
      }
    }
    .rbox {
      flex: 3;
      .rbox_1 {
        height: 15vh;
        position: relative;

        span {
          position: absolute;
          font-weight: 700;
        }

        .chart1 {
          width: 100%;
          height: 100%;
        }
      }
      .rbox_2 {
        display: flex;
        height: 15vh;
        background-color: #fff;
        div {
          flex: 1;
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .l_box_2 {
    height: 30vh;
    margin-top: 1vh;
    .nr_box {
      display: flex;
      .nr_box_l {
        display: flex;
        flex: 5;
        padding: 1vh;
        .nr_box_l1,
        .nr_box_l2 {
          flex: 1;
          height: 20vh;
          background-color: #fff;
          div {
            flex: 1;
            width: 100%;
            height: 100%;
          }
          span {
            line-height: 4vh;
            font-size: calc(100vw * 16 / 1920);
            font-weight: 700;
          }
        }
      }
      .nr_box_r {
        flex: 2;
        .chart1 {
          width: 100%;
          height: 120%;
        }
      }
    }
  }
}
</style>